module.exports = __webpack_public_path__ + "static/media/periphery.b6184add.png";